import { forwardRef } from "react";
import WindowNavPanels from "./WindowNavPanels";
import {
  mintSpaceWindowCardClass,
  mintSpaceSidebarSurfaceClass,
  mintSpaceHairlineClass,
  MINT_SPACE_SIDEBAR_WIDTH,
} from "../styles/mintSpaceChrome";
import { mintSpaceDiscoverCanvasClass } from "../styles/feedSurface";

/**
 * Shared window chrome for Mint Space hub and campaign-details views.
 */
const MintSpaceShell = forwardRef(function MintSpaceShell(
  { isDark, sidebarHeader, sidebarNav, mobileNav, mainTop, children, activePanelKey, renderPanel, windowVariant = "default" },
  ref
) {
  const windowClass =
    windowVariant === "discover" ? mintSpaceDiscoverCanvasClass() : mintSpaceWindowCardClass(isDark);

  return (
    <div className="mint-space-window h-full w-full font-ds" ref={ref}>
      <div className={`h-full overflow-hidden rounded-radius-lg border ${windowClass}`}>
        <div className="flex h-full flex-col lg:flex-row">
          <div
            className={`hidden ${MINT_SPACE_SIDEBAR_WIDTH} flex-shrink-0 flex-col border-r lg:flex ${mintSpaceSidebarSurfaceClass(isDark)}`}
          >
            {sidebarHeader}
            <nav className="campaign-window-scrollbar flex-1 overflow-y-auto px-1.5 py-1.5 text-left">
              {sidebarNav}
            </nav>
          </div>

          <div
            className={`flex overflow-x-auto border-b lg:hidden ${mintSpaceHairlineClass(isDark)} ${mintSpaceSidebarSurfaceClass(isDark)}`}
          >
            {mobileNav}
          </div>

          <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
            {mainTop}
            {activePanelKey != null && renderPanel ? (
              <WindowNavPanels
                activeKey={activePanelKey}
                renderPanel={renderPanel}
                className="min-h-0 flex-1"
              />
            ) : (
              <div className="campaign-window-scrollbar min-h-0 flex-1 overflow-y-auto">
                {children}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default MintSpaceShell;
